import type { CanDeactivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationConfirmationDialogComponent } from '../services/navigation-confirmation.service';
import type { NavigationConfirmationData } from '../services/navigation-confirmation.service';

export const uploadDirtyGuard: CanDeactivateFn<object> = async (component) => {
  // If component doesn't have orchestrator yet, allow navigation
  if (!('orchestrator' in component)) {
    return true;
  }

  const orchestrator = (component as object & { orchestrator?: { classifiedFiles(): unknown[]; savedFiles(): unknown[]; phase(): string } }).orchestrator;
  if (!orchestrator) {
    return true;
  }

  const hasUnsaved = orchestrator.classifiedFiles().length > 0 &&
                     orchestrator.savedFiles().length === 0 &&
                     orchestrator.phase() !== 'idle' &&
                     orchestrator.phase() !== 'summary';

  if (!hasUnsaved) {
    return true;
  }

  const dialog = inject(MatDialog);
  const dialogRef = dialog.open(NavigationConfirmationDialogComponent, {
    data: { question: 'You have classified files that have not been saved. Your credits have been used. Are you sure you want to leave?' } as NavigationConfirmationData,
    disableClose: true,
  });

  return dialogRef.afterClosed().toPromise() ?? false;
};